import React from "react";
import "./ourServicesInfo.css";

const services = [
  {
    title: "Work Visa Processing",
    description: "Efficient and hassle-free work visa application and processing services in Dubai.",
    icon: "🛂",
  },
  {
    title: "HR Consultancy",
    description: "Expert HR solutions to help streamline your organization's workforce management.",
    icon: "📑",
  },
  {
    title: "PRO Services",
    description: "End-to-end public relations officer (PRO) services for businesses and individuals.",
    icon: "🏢",
  },
  {
    title: "Employee Onboarding",
    description: "Comprehensive onboarding solutions to help new employees integrate smoothly.",
    icon: "👨‍💼",
  },
  {
    title: "Payroll Management",
    description: "Accurate and compliant payroll processing tailored to your business needs.",
    icon: "💰",
  },
];

const OurServicesInfo = () => {
  return (
    <div className="services-container">
      <h2 className="services-title">Our Services</h2>
      <p className="services-subtitle">
        Stannum HR Consultancies LLC offers a range of HR solutions and work visa services in Dubai.
      </p>
      <div className="services-grid">
        {services.map((service, index) => (
          <div key={index} className="service-card">
            <div className="service-icon">{service.icon}</div>
            <h3 className="service-title">{service.title}</h3>
            <p className="service-description">{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OurServicesInfo;
